import { useFormatPrice } from '@webapp/core/hooks/useFormatPrice'
import { useProcurifyIntl } from '@webapp/hooks'
import { useFormatPercent } from '@webapp/hooks/useFormatPercent'
import messages from './messages'
import { type TransactionFee } from '../../entities/PaymentMethod'

export const useFormatTransactionFee = () => {
  const intl = useProcurifyIntl()
  const formatPrice = useFormatPrice()
  const formatPercent = useFormatPercent()

  return (transactionFee: TransactionFee, currency: string): string | null => {
    if (!transactionFee) {
      return null
    }

    if (Number(transactionFee.value) === 0) {
      return intl.formatMessage(messages.freeLabel)
    }

    if (transactionFee.type === 'percentage') {
      return formatPercent(transactionFee.value)
    }

    const formattedAmount = formatPrice(transactionFee.value)
    return `${formattedAmount} ${currency}`
  }
}
